const campaignEventModeEnum = Object.freeze({
  SHOW: 0,
  SEND: 1,
  DELAY: 2
})

export { campaignEventModeEnum }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignEventModeEnum.js